<template style="height: 100%;">
  <div class="File_view">
    <el-collapse style="width: 98%;margin-left: 1%;" v-model="activeNames" @change="handleChange">
      <el-collapse-item title="一般信息" name="1">
        <el-descriptions style="margin-top: 20px;width: 98%;margin-left: 1%;"  class="margin-top" :column="4" :size="size">
          <el-descriptions-item label="姓名">{{ data.RealName }}</el-descriptions-item>
          <el-descriptions-item label="姓别">{{ data.Sex == "1" ?'男':"女" }}</el-descriptions-item>
          <el-descriptions-item label="年龄">{{ data.Age }}</el-descriptions-item>
          <el-descriptions-item label="户口类型">{{ data.AccountType == "0" ? '农村' : "城市" }}</el-descriptions-item>
          <el-descriptions-item label="军人证件号">{{ data.UserID }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{ data.Phone }}</el-descriptions-item>
          <el-descriptions-item label="安全邮箱">{{ data.Email }}</el-descriptions-item>
          <el-descriptions-item label="婚姻状态">{{ data.MarriageState }}</el-descriptions-item>
          <el-descriptions-item label="兵种">{{ data.Armylype }}</el-descriptions-item>
          <el-descriptions-item label="军衔">{{ data.ClinicType }}</el-descriptions-item>
          <el-descriptions-item label="文化程度">{{ data.Degree }}</el-descriptions-item>
          <el-descriptions-item label="职级">{{ data.PositionLevel }}</el-descriptions-item>
          <el-descriptions-item label="部队名称">{{ data.DeptID }}</el-descriptions-item>
          <el-descriptions-item label="技术级别">{{ data.SkillType }}</el-descriptions-item>
          <el-descriptions-item label="文职级别">{{ data.Bak2 }}</el-descriptions-item>
          <el-descriptions-item label="是否退役">{{ data.Sex == "1" ? '是' : "否" }}</el-descriptions-item>
          <el-descriptions-item label="入伍时间">{{ data.BntryDate }}</el-descriptions-item>
          <el-descriptions-item label="紧急联系人">{{ data.TheGuardian }}</el-descriptions-item>
          <el-descriptions-item label="紧急联系人电话">{{ data.TheGuardianPhone }}</el-descriptions-item>
          <el-descriptions-item label="出生地">{{ data.Bak3 }}</el-descriptions-item>
          <el-descriptions-item label="生长地">{{ data.Bak4 }}</el-descriptions-item>
          <el-descriptions-item label="心理状况">{{ data.Bak5 }}</el-descriptions-item>
          <el-descriptions-item label="身体状况">{{ data.Bak6 }}</el-descriptions-item>
          <el-descriptions-item label="夫妻感情">{{ data.Bak7 }}</el-descriptions-item>
          <el-descriptions-item label="夫/妻病史">{{ data.Bak8 }}</el-descriptions-item>
          <el-descriptions-item label="个人爱好">{{ data.Bak9 }}</el-descriptions-item>
          <el-descriptions-item label="个人病史">{{ data.Bak10 }}</el-descriptions-item>
          <el-descriptions-item label="自我评价">{{ data.ZSelfIntroduction }}</el-descriptions-item>
          <el-descriptions-item label="家庭经济情况">{{ data.Bak11 }}</el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>

      <el-collapse-item title="家庭情况" name="2">
        <el-descriptions style="margin-top: 20px;width: 98%;margin-left: 1%;" class="margin-top" :column="4" :size="size">
          <el-descriptions-item label="父亲职业"> {{ data.FatherDuty }} </el-descriptions-item>
          <el-descriptions-item label="父亲年龄">{{ data.FatherAge }}</el-descriptions-item>
          <el-descriptions-item label="父亲身体情况">{{ data.FatherState }}</el-descriptions-item>
          <el-descriptions-item label="母亲职业">{{ data.MotherDuty }}</el-descriptions-item>
          <el-descriptions-item label="母亲年龄">{{ data.MotherAge }}</el-descriptions-item>
          <el-descriptions-item label="母亲身体情况">{{ data.MotherState }}</el-descriptions-item>
          <el-descriptions-item label="父亲身体情况">{{ data.MotherState }}</el-descriptions-item>
          <el-descriptions-item label="父母婚姻状况">{{ data.ParentMerryState }}</el-descriptions-item>
          <el-descriptions-item label="父母病史">{{ data.MedicalHistory }}</el-descriptions-item>
          <el-descriptions-item label="是否有姊妹">{{ data.HasSister }}</el-descriptions-item>
          <el-descriptions-item label="是否有子女">{{ data.HasChildren }}</el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>

      <el-collapse-item title="个人成长史" name="3">
        <el-descriptions style="margin-top: 20px;width: 98%;margin-left: 1%;" class="margin-top" :column="4" :size="size">
          <el-descriptions-item label="抚养史"> 0岁~12岁，由 魏紫宸 抚养 </el-descriptions-item>
          <el-descriptions-item label="父亲性格">{{ data.GrowFatherNature }}</el-descriptions-item>
          <el-descriptions-item label="父亲教养方式">{{ data.GrowFatherTrainWay }}</el-descriptions-item>
          <el-descriptions-item label="母亲性格">{{ data.GrowMotherNature }}</el-descriptions-item>
          <el-descriptions-item label="母亲教养方式">{{ data.GrowMotherTrainWay }}</el-descriptions-item>
          <el-descriptions-item label="父母关系">{{ data.CrowParentRelationship }}</el-descriptions-item>
          <el-descriptions-item label="家庭氛围">{{ data.GrowFamilyMood }}</el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>

      <el-collapse-item title="军旅心路" name="4">
        <el-descriptions style="margin-top: 20px;width: 98%;margin-left: 1%;" class="margin-top" :column="4" :size="size">
          <el-descriptions-item label="入伍前工作经历">{{ data.ExperienceBeforeAmry }}</el-descriptions-item>
          <el-descriptions-item label="入伍动机">{{ data.ArmyCause }}</el-descriptions-item>
          <el-descriptions-item label="入伍后适应情况及时间">{{ data.AdaptStateTime }}</el-descriptions-item>
          <el-descriptions-item label="专业技能特长">{{ data.IndividualTraits }}</el-descriptions-item>
          <el-descriptions-item label="任职经历及心理变化情况">{{ data.GrowFamilyMood }}</el-descriptions-item>
          <el-descriptions-item label="参军后自豪的事情">{{ data.GrowFamilyMood }}</el-descriptions-item>
          <el-descriptions-item label="参军后受挫的事情">{{ data.BadlyEventAfterArmy }}</el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>

      <el-collapse-item title="往期记录" name="5">
        <ul class="Record" v-for="item in datalist.categories" :key="item.index">

          <li v-if="item.EventType == 2">
            <div class="Record_left">
              20230130 09:00-09:03
            </div>
            <div class="Record_right">
                <ul>
                  <li>
                    <i style="width: 8px;height: 8px;background: rgba(250, 151, 30, 1);display: inline-block;border-radius: 50%;margin-left: 10px;"></i>
                     记录类型1
                  </li>

                  <li>
                    <i style="width: 14px;height: 8px;'background': rgba(250, 151, 30, 1);display: inline-block;margin-left: 10px;"></i>
                    心理状态
                  </li>

                  <li>
                    <i style="width: 14px;height: 8px;background: rgba(250, 151, 30, 1);display: inline-block;margin-left: 10px;"></i>
                    身体状态
                  </li>

                </ul>

                <ul>
                  <li style="margin-left: 10px;">
                    <span>量表名称：</span>
                    <span></span>
                  </li>
                  <li>
                    <span>测试者姓名：</span>
                    <span></span>
                  </li>
                  <li>
                    <span>总分原始分/标准分：</span>
                    <span></span>
                  </li>
                  <li>
                    <span>测试来源：</span>
                    <span></span>
                  </li>
                </ul>
                <el-button type="primary" size="mini">查看报告</el-button>
            </div>
          </li>



          <li v-if="item.EventType == 1">
              <div class="Record_left">
                20230130 09:00-09:03
              </div>
              <div class="Record_right">
                <ul>

                  <li>
                    <i style="width: 8px;height: 8px;display: inline-block;border-radius: 50%;margin-left: 10px; background-color: rgba(158, 3, 3, 1);"></i>
                      重要记录
                  </li>

                  <li v-if="item.EventDetail.PsychologyStatus == 1">
                    <i style="width: 14px;height: 8px;background: rgba(158, 3, 3, 1);display: inline-block;margin-left: 10px;"></i>
                    心理状态: <span style="color: rgba(158, 3, 3, 1);">红色预警</span>
                  </li>

                  <li v-if="item.EventDetail.PsychologyStatus == 2">
                    <i style="width: 14px;height: 8px;background: rgba(242, 190, 0, 1);display: inline-block;margin-left: 10px;"></i>
                    心理状态: <span style="color: rgba(242, 190, 0, 1);">橙色预警</span>
                  </li>

                  <li v-if="item.EventDetail.PsychologyStatus == 3">
                    <i style="width: 14px;height: 8px;background: rgba(242, 190, 0, 1);display: inline-block;margin-left: 10px;"></i>
                    心理状态: <span style="color: rgba(242, 190, 0, 1);">黄色预警</span>
                  </li>

                  <li v-if="item.EventDetail.PsychologyStatus == 4">
                    <i style="width: 14px;height: 8px;background: rgba(0, 136, 255, 1);display: inline-block;margin-left: 10px;"></i>
                    心理状态: <span style="color: rgba(0, 136, 255, 1);">蓝色预警</span>
                  </li>

                  <li v-if="item.EventDetail.PsychologyStatus == 5">
                    <i style="width: 14px;height: 8px;background: rgba(21, 191, 109, 1);display: inline-block;margin-left: 10px;"></i>
                    心理状态: <span style="color: rgba(21, 191, 109, 1);">绿色预警</span>
                  </li>

                  <li v-if="item.EventDetail.BodyStatus == 1">
                    <i style="width: 14px;height: 8px;background: rgba(158, 3, 3, 1);display: inline-block;margin-left: 10px;"></i>
                    身体状态: <span style="color: rgba(158, 3, 3, 1);">红色预警</span>
                  </li>

                  <li v-if="item.EventDetail.BodyStatus == 2">
                    <i style="width: 14px;height: 8px;background: rgba(242, 190, 0, 1);display: inline-block;margin-left: 10px;"></i>
                    身体状态: <span style="color: rgba(242, 190, 0, 1);">橙色预警</span>
                  </li>

                  <li v-if="item.EventDetail.BodyStatus == 3">
                    <i style="width: 14px;height: 8px;background: rgba(242, 190, 0, 1);display: inline-block;margin-left: 10px;"></i>
                    身体状态: <span style="color: rgba(242, 190, 0, 1);">黄色预警</span>
                  </li>

                  <li v-if="item.EventDetail.BodyStatus == 4">
                    <i style="width: 14px;height: 8px;background: rgba(0, 136, 255, 1);display: inline-block;margin-left: 10px;"></i>
                    身体状态: <span style="color: rgba(0, 136, 255, 1);">蓝色预警</span>
                  </li>

                  <li v-if="item.EventDetail.BodyStatus == 5">
                    <i style="width: 14px;height: 8px;background: rgba(21, 191, 109, 1);display: inline-block;margin-left: 10px;"></i>
                    身体状态: <span style="color: rgba(21, 191, 109, 1);">绿色预警</span>
                  </li>
                </ul>

                <ul>
                  <li style="margin-left: 10px;">
                    <span>关键人物：</span>
                    <span></span>
                  </li>
                  <li>
                    <span>测试者姓名：</span>
                    <span></span>
                  </li>
                  <li>
                    <span>总分原始分/标准分：</span>
                    <span></span>
                  </li>
                  <li>
                    <span>测试来源：</span>
                    <span></span>
                  </li>
                </ul>
                <p style="height: 80px;">2222222</p>
                <!-- <el-button type="primary" size="mini">查看报告</el-button> -->
              </div>
            </li>
        </ul>
      </el-collapse-item>

    </el-collapse>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeNames: ['5'],
      size: '',
      data: [],
      datalist:[],
    }
  },
  components: {

  },
  methods: {
    handleChange(val) {
    }
  },
  watch: {

  },
  mounted() {
    this.$Http_Post('SoldierFile/SoldierFileInfo', { "UserID": this.$route.query.id }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data;
      }
    });

    this.$Http_Post('SoldierFile/SoldierFileRecord', { "UserID": this.$route.query.id }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.datalist = res.Data;
      }
    });
  }
}
</script>

<style>
  .File_view{height: 100%;background-color: #fff;overflow: auto;}
  .File_view tbody td{border:none;line-height: 30px !important;}
  .Record{margin-top: 20px;width: 100%;}
  .Record_left{float: left;line-height: 100px;margin-left: 20px;width: 140px;}
  .Record_right{border-left: 1px solid #959595;float: left;margin-left: 20px;margin-top: 10px;width: calc(100% - 241px);}
  .Record_right ul{width: 100%;height: 30px;}
  .Record_right ul li{float: left;}
  .Record>li {background: rgba(250, 250, 250, 1);height: 100%;}
  
</style>
